import { END_POINTS } from '../helpers';
import { ReceiveNotification } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
  body: any;
  status: number;
};

export interface ReceiveNotificationResponse {
  NotificationData: ReceiveNotification[];
  NotificationCount: number;
}

export const notificationsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addNotification: builder.mutation<CommonResponseType & { data: any }, any>({
      query: (body) => ({
        url: END_POINTS.notification,
        method: 'POST',
        body,
      }),
    }),

    getNotification: builder.query<
      CommonResponseType & { data: any },
      { page: number; limit: number; search: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.getNotification}?page=${page}&limit=${limit}&search=${search}`,
        method: 'GET',
      }),
    }),

    deleteNotificationById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.notification}/${id}`,
        method: 'DELETE',
      }),
    }),

    getReceiveNotification: builder.query<
      CommonResponseType & { data: ReceiveNotificationResponse },
      { page: number; limit: number }
    >({
      query: ({ page, limit }) => ({
        url: `${END_POINTS.receivedNotification}?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
    }),

    deleteReceiveNotificationById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.receivedNotificationDeleteById}/${id}`,
        method: 'DELETE',
      }),
    }),
    deleteAllReceiveNotification: builder.query<CommonResponseType, void>({
      query: () => ({
        url: `${END_POINTS.receivedNotificationDeleteAll}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useAddNotificationMutation,
  useLazyGetNotificationQuery,
  useDeleteNotificationByIdMutation,
  useLazyGetReceiveNotificationQuery,
  useDeleteReceiveNotificationByIdMutation,
  useLazyDeleteAllReceiveNotificationQuery,
} = notificationsApi;
